import React from 'react'

import { A } from '@frame/ui-primitives/a'

export function LearnMore() {
  return (
    <>
      Truework may keep connections open to help expedite your application process.{' '}
      <A href="https://help.truework.com/hc/en-us/articles/15703476003863" target="_blank" rel="noreferrer">
        Learn more
      </A>
    </>
  )
}
